<div class="horizontal-form">
    <div class="dropdown">
        <aa-filter-tag-input [placeholder]="'CMDB.TAGS.FILTER.PLACEHOLDER' | translate"
                            [disabled]="false"
                            [tags]="availableTags | async"
                            (selectTag)="onSelectTag($event)">
        </aa-filter-tag-input>
    </div>
    <div class="tags">
        <aa-filter-tag-item [tag]="tag"
                     *ngFor="let tag of filterTags | async"
                     (unselectTag)="onUnselectTag($event)"
                     (toggleIncludedTag)="onToggleIncludedTag($event)"
                     (toggleEnabledTag)="onToggleEnabledTag($event)">
        </aa-filter-tag-item>
    </div>
    <div class="clear">
        <a *ngIf="!isEmptyTagList"
           class="medium-text-link"
           (click)="onClearAll()">{{ 'CMDB.TAGS.FILTER.CLEARALL' | translate}}</a>
    </div>
</div>
